import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button } from '@heroui/react';
import { Icon } from '@iconify/react';
import { useTheme } from '../stores/theme-store';
import { ThemeToggler, type ThemeSelection } from './animate-ui/primitives/effects/theme-toggler';

export const ThemeSwitcher: React.FC = () => {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const themeOptions = [
    {
      key: 'system',
      label: 'سیستم',
      icon: 'solar:monitor-bold',
      description: 'هماهنگ با تم سیستم‌عامل',
    },
    {
      key: 'light',
      label: 'روشن',
      icon: 'solar:sun-bold',
      description: 'تم روشن',
    },
    {
      key: 'dark',
      label: 'تاریک',
      icon: 'solar:moon-bold',
      description: 'تم تاریک',
    },
  ];

  const activeTheme = mounted ? (theme || 'light') : 'light';
  const currentThemeOption = themeOptions.find((opt) => opt.key === activeTheme) || themeOptions[1];

  return (
    <ThemeToggler
      theme={(theme || 'light') as ThemeSelection}
      resolvedTheme={resolvedTheme || 'light'}
      setTheme={setTheme}
    >
      {({ toggleTheme }) => (
        <Dropdown>
          <DropdownTrigger>
            <Button
              isIconOnly
              variant="light"
              aria-label="Theme switcher"
              className="text-default-600 hover:text-default-900 bg-white/70 dark:bg-black/30 backdrop-blur-md"
            >
              <Icon
                icon={currentThemeOption.icon}
                className="text-2xl"
              />
            </Button>
          </DropdownTrigger>
          <DropdownMenu
            aria-label="Theme selection"
            selectedKeys={new Set([activeTheme])}
            selectionMode="single"
            onSelectionChange={(keys) => {
              const selected = Array.from(keys)[0] as string;
              if (selected && selected !== theme) {
                toggleTheme(selected as ThemeSelection);
              }
            }}
          >
            {themeOptions.map((option) => (
              <DropdownItem
                key={option.key}
                startContent={<Icon icon={option.icon} className="text-xl" />}
                description={option.description}
              >
                {option.label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      )}
    </ThemeToggler>
  );
};

export default ThemeSwitcher;
